import React from "react";
import { motion } from "framer-motion";
import styles from "./Hero.module.scss";

const Hero = () => {
  return (
    <section className={styles.heroContainer}>
      <div className={styles.heroBg}>
        <div className={styles.heroBgVideo}>
          <video src="/bannerBgVideo.mp4" autoPlay muted loop playsInline />
        </div>
        <div className={styles.heroBgImg}>
          <img src="/bannerBg1.webp" alt="HeroBgImg" />
        </div>
        <div className={styles.heroBgImg}>
          <img src="/bannerBg2.webp" alt="HeroBgImg" />
        </div>
        <div className={styles.heroBgImg}>
          <img src="/bannerBg3.webp" alt="HeroBgImg" />
        </div>
      </div>
      <div className="container-custom relative z-10 text-center max-w-full relative z-2">
        <div className="max-w-[128rem]  mx-auto px-4 sm:px-6 lg:px-8">
          {/* Badge Top Headline */}
          <motion.div
            className={`${styles.badgeLogo} mx-auto m-6`}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              duration: 0.8,
              ease: "easeOut",
              delay: 0.2,
            }}
          >
            <div className={styles.logoCount}>Vertik</div>
            <div className={styles.logoDetail}>Your AI sales companion</div>
          </motion.div>

          {/* Main Headline */}
          <motion.h1
            className={`${styles.mainHeadline} mb-6 sm:mb-4 sm:mb-3`}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              duration: 0.8,
              ease: "easeOut",
              delay: 0.4,
            }}
          >
            <p>
              A<span className={styles.gradientText}></span>
            </p>
            <p>
              <motion.span
                className={`${styles.gradientText} ${styles.smartAiText} sm:mr-4 `}
                animate={{
                  rotateY: [45, -45],
                }}
                transition={{
                  duration: 5,
                  ease: "easeInOut",
                  repeat: Infinity,
                  repeatType: "loop",
                }}
              >
                Chief of Staff
              </motion.span>
              for every Seller.
            </p>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            className={`${styles.subtitleText} mb-4 sm:mb-4 xs:mb-3`}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              duration: 0.8,
              ease: "easeOut",
              delay: 0.6,
            }}
          >
            Connect, automate, and accelerate your entire sales workflow from
            lead to closure
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            className="flex flex-col sm:flex-row gap-8 justify-center items-center mb-12 sm:mb-8 xs:mb-6"
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              duration: 0.8,
              ease: "easeOut",
              delay: 0.8,
            }}
          >
            <button
              className={styles.getStartedBtn}
              onClick={() => {
                const contactSection = document.querySelector("#contact");
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <span>Get Early Access</span>
            </button>
            <button
              className={styles.seeHowBtn}
              onClick={() => {
                const howItWorksSection = document.querySelector("#how-it-works");
                if (howItWorksSection) {
                  howItWorksSection.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <span>See how Vertik works</span>
              <img src="/forwardArrow.svg" alt="" aria-hidden="true" />
            </button>
          </motion.div>

          {/* Partnership Brands */}
          <motion.p
            className={`${styles.partnershipText} mb-6 sm:mb-4 xs:mb-3`}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              duration: 0.8,
              ease: "easeOut",
              delay: 1.0,
            }}
          >
            DESIGNED FOR MODERN B2B SALES TEAMS
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
